/**
 * Pollo Wan 2.2 Plus：input 结构单独封装
 * 图生：image 必填，resolution 480P|1080P，length 固定 5
 * 文生：prompt 必填，resolution 480P|1080P，length 5，aspectRatio 仅文生
 */
import { isUrl } from './utils'

var RES_MAP = { '480p': '480P', '480P': '480P', '720p': '1080P', '720P': '1080P', '1080p': '1080P', '1080P': '1080P' }

function normalizeResolution(v) {
  if (!v) return '1080P'
  var key = String(v).trim()
  return RES_MAP[key] || '1080P'
}

export function buildBody(params) {
  var hasImage = isUrl(params.referenceImage)
  var input = {
    prompt: (params.prompt || '').trim().slice(0, 800),
    negativePrompt: (params.negativePrompt || '').trim().slice(0, 500) || undefined,
    resolution: normalizeResolution(params.videoRes || params.resolution),
    length: 5,
    seed: undefined
  }
  var seed = params.seed != null && params.seed !== '' && params.seed !== -1 ? parseInt(params.seed, 10) : null
  if (seed != null && !isNaN(seed) && seed <= 2147483647) input.seed = seed
  if (hasImage) {
    input.image = params.referenceImage.trim()
  } else {
    input.aspectRatio = (params.aspectRatio || '16:9').replace(/：/g, ':')
  }
  var body = { input: input }
  if (params.webhookUrl && isUrl(params.webhookUrl)) body.webhookUrl = params.webhookUrl
  return body
}
